import * as React from 'react';
import Typography from "@mui/material/Typography";
import { Box } from "@mui/material";
import { useState } from "react";
import RefreshIcon from '@mui/icons-material/Refresh';
import ReplayIcon from '@mui/icons-material/Replay';
import KeyboardDoubleArrowLeftIcon from '@mui/icons-material/KeyboardDoubleArrowLeft';
import KeyboardDoubleArrowRightIcon from '@mui/icons-material/KeyboardDoubleArrowRight';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import useStore from "../../../../store/store";

const PowerRegulatorComponent = () => {
    const [value, setValue] = useState(0.01);
    const [selectedIndex, setSelectedIndex] = useState(10);

    const stepValues = [20, 10, 5, 2, 1, 0.5, 0.2, 0.1, 0.05, 0.02, 0.01];

    const eng = useStore((state) => state.eng);

    const handleIncrement = () => {
        const currentIndex = stepValues.indexOf(value);
        const nextIndex = Math.min(currentIndex + 1, stepValues.length - 1);
        setValue(stepValues[nextIndex]);
        setSelectedIndex(nextIndex);
    };

    const handleDecrement = () => {
        const currentIndex = stepValues.indexOf(value);
        const nextIndex = Math.max(currentIndex - 1, 0);
        setValue(stepValues[nextIndex]);
        setSelectedIndex(nextIndex);
    };

    const handleResetLeft = () => {
        setValue(20);
        setSelectedIndex(stepValues.indexOf(20));
    };

    const handleResetRight = () => {
        setValue(0.01);
        setSelectedIndex(stepValues.indexOf(0.01));
    };

    const rotationAngle = (selectedIndex / stepValues.length) * 360;

    return (
        <Box sx={{ display: 'flex', alignItems: 'center' }}>
            <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', marginLeft: '20px' }}>
                {/*<Box sx={{display: 'flex', flexDirection: 'row'}}>*/}
                {/*    <Box sx={{marginRight: '30px', marginBottom: '5px'}}>0.5</Box>*/}
                {/*    <Box sx={{marginLeft: '-10px'}}>0.2</Box>*/}
                {/*</Box>*/}
                <Box sx={{display: 'flex'}}>
                    {/*<Box sx={{display: 'flex', flexDirection: 'column', justifyContent: 'space-between'}}>*/}
                    {/*    <Box sx={{marginLeft: '10px'}}>1</Box>*/}
                    {/*    <Box>2</Box>*/}
                    {/*    <Box sx={{marginBottom: '10px'}}>5</Box>*/}
                    {/*</Box>*/}
                    <Box
                        sx={{
                            position: 'relative',
                            width: '75px',
                            height: '75px',
                            borderRadius: '50%',
                            backgroundColor: 'gray',
                            fontSize: '1.2em',
                            cursor: 'pointer',
                            overflow: 'hidden',
                        }}
                    >
                        <Box
                            sx={{
                                position: 'absolute',
                                top: '70%',
                                left: '50%',
                                transform: `translate(-50%, -50%) rotate(${rotationAngle}deg)`,
                                width: '2px',
                                height: '25px',
                                backgroundColor: 'black',
                                transformOrigin: 'top',
                            }}
                        />
                    </Box>
                    {/*<Box sx={{display: 'flex', flexDirection: 'column', justifyContent: 'space-between'}}>*/}
                    {/*    <Box>0.1</Box>*/}
                    {/*    <Box sx={{marginLeft: '5px'}}>0.05</Box>*/}
                    {/*    <Box sx={{marginBottom: '10px'}}>0.02</Box>*/}
                    {/*</Box>*/}
                </Box>
                {/*<Box sx={{display: 'flex', flexDirection: 'row', marginRight: '20px'}}>*/}
                {/*    <Box>10</Box>*/}
                {/*    <Box sx={{margin: '2px 20px 0 20px'}}>20</Box>*/}
                {/*    <Box>0.01</Box>*/}
                {/*</Box>*/}

                {/*<Box sx={{ display: 'flex', marginTop: '30px' }}>*/}
                {/*    <button onClick={handleResetLeft}><KeyboardDoubleArrowLeftIcon/></button>*/}
                {/*    <button onClick={handleDecrement}><ReplayIcon/></button>*/}
                {/*    <button onClick={handleIncrement}><RefreshIcon/></button>*/}
                {/*    <button onClick={handleResetRight}><KeyboardDoubleArrowRightIcon/></button>*/}
                {/*</Box>*/}
                <Box sx={{display: 'flex', flexDirection: 'column', fontWeight: 'bold', marginTop: '0px'}}>
                    <Typography><ArrowDropDownIcon />{eng ? '5DIV.' : '5ДIЛ.'}</Typography>
                    <Typography sx={{color: '#307771', fontWeight: 'bold'}}>{eng ? 'AMPLIFICATION': 'ПОСИЛЕННЯ'}</Typography>
                </Box>
            </Box>
        </Box>
    );
};

export default PowerRegulatorComponent;
